import React, { useRef, useState, useEffect, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { ChromePicker } from 'react-color';
import '../../assets/scss/app/blocks/template-selector.scss';
import { 
    TPLS_COLOR, 
    TPLTS, 
    DEFAULT_TEMPLATE_COLOR, 
    DEFAULT_VARIANT_COLOR, 
    OLD_COLOR_CODES 
} from '../../constants/constants';
import ListTemplate from '../ListTemplate';
import StyleControls from '../common/StyleControls';
import WpAPI from '../../WpApi';
import { useUser } from '../../context/UserContext';

const TemplateSelector = (props) => {
    const [customTemplateColor, setCustomTemplateColor] = useState('');
    const [toogleColorPicker, setToogleColorPicker] = useState(false);
    const { store } = useContext(ReactReduxContext);
    const ddRef = useRef();

    const onClickOutside = (e) => {
        if (e.target.className != '') {
            setToogleColorPicker(false);
        }
    }

    const updateTemplateCustomColor = (color_code) => {
        setCustomTemplateColor(color_code);
        props.handlers.updateResumePreview({ custom_template_color: color_code });
    }

    const getTemplateColorCode = () => {
        if (DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[props.resume.active_color]] == undefined) {
            return props.resume?.custom_template_color ?
                props.resume.custom_template_color :
                (props.resume?.active_color ?
                    DEFAULT_VARIANT_COLOR[props.resume?.active_color] :
                    DEFAULT_TEMPLATE_COLOR[props.resume?.active_template]);
        } else {
            return props.resume?.custom_template_color ?
                props.resume.custom_template_color :
                (props.resume?.active_color ?
                    DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[props.resume.active_color]] :
                    DEFAULT_TEMPLATE_COLOR[props.resume?.active_template]);
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    return (<><div className="no-print template-selector-wrap">
        <div className={`no-print left-panel`}>
            <div className={`panel templates`}>
                <div className="color-palette-wrap">
                    <div className="color-palette">
                        <span className="color-label">Colors:</span>
                        <ul className="color-selector">
                            {TPLS_COLOR.map((color, index) => {
                                return (<li className={`item` + index} key={index}>
                                    <label title="" className="label">
                                        <input
                                            type="radio"
                                            name="select-color"
                                            value={color.id}
                                            onChange={(e) => {
                                                props.handlers.updateResumePreview({ custom_template_color: '', active_color: color.id, heading_color: '' });
                                                setCustomTemplateColor(color.color_code);
                                                updateTemplateCustomColor(color.color_code);
                                                ga4Track('app_ts_editor_color', 'RB App', 'Template Selector Color Dropdown');
                                            }}
                                        />
                                        <span
                                            className={`color-selector-radio ` + color.id}
                                            style={{ backgroundColor: color.color_code }}
                                        ></span>
                                    </label>
                                </li>)
                            })}
                        </ul>
                    </div>
                    <div className="multi-color-selector">
                        <div className="multiple-color" style={{ position: 'relative' }} onClick={(e) => {
                            setToogleColorPicker(true);
                            e.stopPropagation();
                        }}>
                            <span className="color-picker">
                                {<i className="color-square" style={{ backgroundColor: getTemplateColorCode() }}></i>}
                            </span>
                            {toogleColorPicker ? <div className="quick-chrome-picker-wrap" ref={ddRef}>
                                <ChromePicker
                                    color={getTemplateColorCode()}
                                    onChange={(e) => { setCustomTemplateColor(e.hex) }}
                                    onChangeComplete={(e) => {
                                        updateTemplateCustomColor(e.hex);
                                        ga4Track('app_ts_editor_color', 'RB App', 'Template Selector Color Dropdown');
                                    }}
                                    disableAlpha={true} /></div> : ''}
                            <label htmlFor="quick-color-picker" className="custom-label">{getTemplateColorCode()}</label>
                        </div>
                    </div>
                </div>
                <div className="template-list-wrap">
                    <div className="template-list">
                        <ListTemplate
                            templates={TPLTS
                                .filter(t => t.hasOwnProperty('resume') && t.resume)
                                .sort((a, b) => (b?.resume_listing_priority - a.resume_listing_priority))}
                            color={''}
                            customColor={customTemplateColor}
                            headerColor={''}
                            page={"quick-editor"}
                            updateResumePreview={props.handlers.updateResumePreview}
                            onsaveResume={props.handlers.onsaveResume}
                            resume={props.resume}
                        />
                    </div>
                </div>
            </div>
            <div className={`style-options-wrap`}>
                <div className="style-options">
                    <StyleControls />
                </div>
            </div>
        </div>
    </div>
    </>);
}
export default TemplateSelector;